<template>
  <div>
    <loader :loader="sending" />
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      sort-by="startTime"
      :sort-desc="true"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          left
          v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_VIEW)"
          color="primary"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="isViewDetailsTable(item.idMedicalPractice)">
              <v-icon color="blue" v-bind="attrs" v-on="on">
                mdi-information-variant
              </v-icon>
            </v-btn>
          </template>
          <span>Ver información </span>
        </v-tooltip>

        <v-menu offset-y :nudge-width="200" :close-on-content-click="true">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip left color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <v-list dense>
            <v-list-item
              link
              @click="isEditableTable(item.idMedicalPractice)"
              v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_EDIT)"
            >
              <v-list-item-icon>
                <v-icon color="warning" small> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              @click="generatePDF(item)"
              v-if="
                $utilFront.withPermission($prm.MODULE_COLPOSCOPY_DOWNLOAD_PDF)
              "
            >
              <v-list-item-icon>
                <v-icon color="error" small> mdi-file-pdf-box </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Colposcopia</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.startTime) }}
      </template>
    </v-data-table>
    <v-card-actions align="center">
      <v-col
        v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_EXPORT_EXCEL)"
      >
        <v-btn
          outlined
          small
          color="green darken-1"
          :disabled="sending"
          @click="downloadReportXLSX()"
        >
          Exportar atenciones
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
  </div>
</template>

<script>
import ScheduleAppointmentDialog from "@/app/components/reception/ScheduleAppointmentDialog.vue";
import ColposcopyHistoryService from "@/app/services/ColposcopyHistoryService";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import Loader from "@/app/components/base/loader/Loader.vue";

export default {
  name: "ColposcopyHistoryTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
    doAction: Function,
    range: Object,
    idBranchOffice: String,
    search: String,
  },
  components: {
    MenuCrud,
    ScheduleAppointmentDialog,
    Loader,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      sending: false,
      idPatient: null,
      dialogProductivity: false,
      dataModal: {},
      dateProductivity: new Date(),
      headers: [
        {
          text: "Id atención",
          value: "idMedicalPractice",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Nombre del paciente",
          value: "fullName",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Responsable",
          value: "fullNameDoctor",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Fecha y hora de atención",
          value: "startTime",
          align: "center",
          sortable: false,
          width: "15%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    generatePDF({ idMedicalPractice, time, idPatient }) {
      this.sending = true;
      if (idMedicalPractice) {
        const data = {
          idMedicalPractice,
          fileName: "COLPOSCOPIA.pdf",
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
          idPatient,
        };
        ColposcopyHistoryService.pdf(data)
          .then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    isViewDetailsTable(id) {
      let isViewDetails = true;
      this.$emit("isViewDetails", isViewDetails);
      this.get(id, 3);
    },
    isEditableTable(id) {
      let isViewDetails = false;
      this.$emit("isViewDetails", isViewDetails);
      this.get(id, 3);
    },
    downloadReportXLSX() {
      if (!this.sending) {
        this.sending = true;

        let data = {
          search: this.search,
          idBranchOffice: this.$utilFront.nonEmpty(
            this.idBranchOffice,
            this.$utilFront.getIdBranchOffice()
          ),
        };

        let rangeName = "";

        if (this.$utilFront.nonEmpty(this.range)) {
          data.start = this.$utilFront.startOfDay(this.range.start);
          data.end = this.$utilFront.endOfDay(this.range.end);
          rangeName = ` del ${this.$utilFront.formatDate(
            data.start
          )} al ${this.$utilFront.formatDate(data.end)}`;
        }

        let fileName = `Historial de atenciones - Colposcopia${rangeName}.xlsx`;

        ColposcopyHistoryService.excel(data)
          .then((res) => {
            let { data } = res;
            this.$utilFront.downloadXLSX(data, fileName);
          })
          .catch((error) => {
            this.$utilFront.errorhttp(error);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

  },
};
</script>
